export default __webpack_public_path__ + "static/media/SH5.36c05a87.jpg";